// extracted by mini-css-extract-plugin
export default {"home":"Home_home__ncRbW","icon":"Home_icon__7HEeG","links":"Home_links__-Btgj"};